import React from 'react';
import Navbar from '../components/Navbar';
import '../pages/Blog.css';

function BuildingCloudRhino() {
  return (
    <div>
      <Navbar />
      <div className="blog-container">
        <h1>Our Journey: Building Cloud Rhino</h1>
        <p className="blog-date">Published on August 15, 2024</p>
        <p>Building a startup is a challenging yet rewarding experience. In this post, we share the story behind Cloud Rhino, the challenges we've faced, and our vision for the future. From the initial idea to where we are now, the journey has been filled with learning and growth...</p>
        {/* Add the full content of your blog post here */}
      </div>
    </div>
  );
}

export default BuildingCloudRhino;
